<template lang="pug" functional>
  .xsell
    .title-wrap.text-center
      h3.xs-f-small.max-at-tweak(data-mr-ass="cross-sell-view")
        span.lovely-script.color-purple.xs-f-xxxgrande.max-at-tweak better color
        br
        span.color-slate.upper.bold.xs-f-small.max-at-tweak  in one click

    slot

</template>

<script>
  export default {
    name: "Xsell"
  }
</script>

<style scoped lang="stylus">
  .xsell
    padding 1em 0


    .title-wrap
      padding 1.5em 0

      .lovely-script
        line-height 1em

    @media mq-desktop-plus
      padding 0 10%

</style>

<style lang="stylus">
  .xsell
    .xsell-product
      padding 2em 0 !important

      &:not(:last-child)
       border-bottom 1px solid color-fog-light
</style>